import React from 'react';
import { Container } from 'reactstrap';

import PasswordResetRequestForm from 'shared/components/PasswordResetRequestForm';
import SEO from 'shared/components/SEO';

function PasswordResetRequestPage() {
  return (
    <Container className="mt-4">
      <SEO
        title="Wachtwoord wijzigen"
        description="Wachtwoord vergeten? Geen nood. Vraag hier een wachtwoord reset aan."
        canonical="/password-reset-request"
      />
      {/* {errorMessage && (
        <Alert color="danger" className="sticky-top text-center" isOpen>
          <span>{errorMessage}</span>
        </Alert>
      )} */}
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ marginTop: '10vh' }}
      >
        <h1>Wachtwoord vergeten?</h1>
        <p className="mt-3 mb-5 text-center">
          Geen zorgen. Vul je e-mailadres in en we sturen je een link waarmee je een nieuw
          wachtwoord kan ingeven.
        </p>
        <PasswordResetRequestForm />
      </div>
    </Container>
  );
}

export default PasswordResetRequestPage;
